import { POSLogo } from "@faire/retailer-visitor-shared/features/PointOfSale/components/POSLogo";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const OpenSizingVariantPOSInventory: React.FC<{
  count: number;
}> = ({ count }) => {
  const { type } = usePOSSummary();

  return (
    <Row align="center" gap={4}>
      <POSLogo type={type} size={12} />
      <Typography>
        {count > 99 ? (
          <StrictLocalMsg
            defaultMessage="99+"
            description={{
              text: "Indicates the current inventory for a given product when it exceeds 99 items, refer to image",
              img: "https://cdn.faire.com/fastly/cac7a1a5149949c5505279e1084ad7308f3fa6a84a03538299442c657ef15c65.png",
            }}
          />
        ) : (
          count
        )}
      </Typography>
    </Row>
  );
};
